import { Component, OnInit, Input } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-text-field[propertyName][formGroup]',
  templateUrl: './text-field.component.html',
  styles: [],
  standalone: false,
})
export class TextFieldComponent extends BaseFormComponent implements OnInit {

  @Input() maxLength?: number;
  @Input() columns: number;
  @Input() FIELD_SPACING: number;
  @Input() LABEL_SPACING: number = 0;
  @Input() regular?: boolean;
  @Input() label2?: string;
  @Input() TITLE_COLUMNS: string = '9';
  
  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  ngOnInit() {
    super.ngOnInit();
    if ( this.maxLength == null ) {
      this.maxLength = 45; // Default field length
    }
  }
 
}
